import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
const advancedApprovalStateVar = makeVar({});
const INITIAL_STATE = {
    skipped: false,
    response: undefined,
    latestPromptId: undefined,
};
export const useAdvancedApprovalState = (documentId) => {
    const state = useReactiveVar(advancedApprovalStateVar);
    const documentState = state[documentId] || INITIAL_STATE;
    const setDocumentState = (newState) => {
        const currentState = advancedApprovalStateVar();
        const currentDocumentState = currentState[documentId] || INITIAL_STATE;
        advancedApprovalStateVar(Object.assign(Object.assign({}, currentState), { [documentId]: Object.assign(Object.assign({}, currentDocumentState), newState) }));
    };
    const resetDocumentState = () => {
        setDocumentState(INITIAL_STATE);
    };
    return Object.assign(Object.assign({}, documentState), { setDocumentState, resetDocumentState });
};
